"use strict";

exports.__esModule = true;
exports.DevicePropertyElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _DevicePropertyElement = require("./DevicePropertyElement.legacy");
var _DevicePropertyElement2 = require("./DevicePropertyElement.modern");
// Flag-gated UI: `DevicePropertyElement.legacy` is the component as it is on master,
// `DevicePropertyElement.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var DevicePropertyElement = exports.DevicePropertyElement = (0, _uiSwitch.uiSwitch)(_DevicePropertyElement.DevicePropertyElement, _DevicePropertyElement2.DevicePropertyElement, "DevicePropertyElement");